import { Component, OnInit, Input, ChangeDetectorRef, NgZone } from '@angular/core';
import { switchMap } from 'rxjs/operators';
import { HelpersService } from '../../../services/tools/helpers.service';
import { PromotoresService } from '../../../services/promotores.service';
import { CreditosService } from '../../../services/creditos.service';

@Component({
  selector: 'app-formulario-promotor',
  templateUrl: './formulario-promotor.component.html'
})
// ... (imports permanecen igual)

export class FormularioPromotorComponent implements OnInit {
  @Input() public idCreditos: number = null;
  @Input() public isEditable: boolean = false;
  public isLoading: boolean = false;
  public promotores: any[] = [];
  private isInitialized: boolean = false;

  public selectedPromotorId: any = null;
  public selectedAnalistaId: any = null;
  public selectedOperadorId: any = null;
  public selectedAsesorId: any = null;

  constructor(
    private helperService: HelpersService,
    private service: PromotoresService,
    private creditosService: CreditosService,
    private cd: ChangeDetectorRef,
    private zone: NgZone,
  ) { }

  ngOnInit() { }

  public loadComponent() {
    if (!this.isInitialized) {
      this.getDatosCredito(this.idCreditos);
      this.isInitialized = true;
    }
  }

  private getDatosCredito(idCreditos: number) {
  this.isLoading = true;
  this.creditosService.get(idCreditos).pipe(
    switchMap(response => {
      const credito = response.json().content;
      return this.service.getAll({ order: 'nombre' }).pipe(
        switchMap(resPromotores => {
          this.promotores = resPromotores.json().content;
          this.isLoading = false;

          // Usamos zone.run para asegurar que la asignación sea detectada
          this.zone.run(() => {
            this.selectedPromotorId = this.parseId(credito.promotor);
            this.selectedAnalistaId = this.parseId(credito.analista);
            this.selectedOperadorId = this.parseId(credito.operador);
            this.selectedAsesorId = this.parseId(credito.asesor);
            
            // Forzamos la detección de cambios después de asignar los IDs
            setTimeout(() => this.cd.detectChanges());
          });

          return [];
        })
      );
    })
  ).subscribe(
    () => {},
    error => {
      this.isLoading = false;
      this.helperService.httpGlobalError(error);
    }
  );
}


  // Crea una función auxiliar para limpiar los IDs
  private parseId(val: any): number | null {
    const id = (val && typeof val === 'object') ? val.id : val;
    return id ? parseInt(id, 10) : null;
  }

  // Actualiza estas funciones en tu archivo .ts

public onSelectedPromotor(val: any) {
    // Al ser nativo, el cambio es instantáneo
    this.selectedPromotorId = val === 'null' ? null : parseInt(val, 10);
}

public onSelectedAnalista(val: any) {
  this.zone.run(() => {
    this.selectedAnalistaId = this.parseId(val);
    this.cd.detectChanges();
  });
}

public onSelectedOperador(val: any) {
  this.zone.run(() => {
    this.selectedOperadorId = this.parseId(val);
    this.cd.detectChanges();
  });
}

public onSelectedAsesor(val: any) {
  this.zone.run(() => {
    this.selectedAsesorId = this.parseId(val);
    this.cd.detectChanges();
  });
}


  public savePromotor() {
  this.isLoading = true;

  const extractId = (val: any) => {
    if (!val) return null;
    const id = (typeof val === 'object' && val.id) ? val.id : val;
    return isNaN(id) ? null : parseInt(id, 10);
  };

  const data = {
    id: this.idCreditos,
    promotor_id: extractId(this.selectedPromotorId),
    analista_id: extractId(this.selectedAnalistaId),
    operador_id: extractId(this.selectedOperadorId),
    asesor_id: extractId(this.selectedAsesorId)
  };

  this.creditosService.updatePromotor(data).subscribe(
    () => {
      this.helperService.notification('Éxito', 'Personal actualizado', 'success');
      this.getDatosCredito(this.idCreditos); // 🔥 solo esto
    },
    error => {
      this.isLoading = false;
      this.helperService.httpGlobalError(error);
    }
  );
}


}


// WEBPACK FOOTER //
// ./src/app/creditos/components/formulario-promotor/formulario-promotor.component.ts